import { render, staticRenderFns } from "./saas_apply_open.vue?vue&type=template&id=6f050cdb&scoped=true"
import script from "./saas_apply_open.vue?vue&type=script&lang=js"
export * from "./saas_apply_open.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f050cdb",
  null
  
)

export default component.exports